import React, { useState } from 'react';
import styled from 'styled-components';
import ModifyChangeCellPhoneNumber from './ModifyChangeCellPhoneNumber';
import ModifyChangeEmail from './ModifyChangeEmail';

const ModifyItemHasInput = ({ title, description, type }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container>
      <ModifyItemHasInputContainer className='d-flex flex-row align-items-center border-bottom border-bottom-1 border-gray-200'>
        <div className='d-flex flex-row'>
          <ModifyItemHasInputTitleWrapper>
            <ModifyItemHasInputTitle className='text-gray-600'>
              {title}
            </ModifyItemHasInputTitle>
          </ModifyItemHasInputTitleWrapper>
          <ModifyItemHasInputTextWrapper className='pl-2'>
            <ModifyItemHasInputText className='text-gray-800 mb-0'>
              {description}
            </ModifyItemHasInputText>
          </ModifyItemHasInputTextWrapper>
        </div>
        <ModifyItemHasInputChangeButton
          className='position-absolute text-gray-500'
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <small>변경</small>
          <ModifyItemHasInputChangeButtonIcon className='i-chevronDown ' />
        </ModifyItemHasInputChangeButton>
      </ModifyItemHasInputContainer>
      {isOpen && type === 'email' && (
        <ModifyChangeEmail setIsOpen={setIsOpen} />
      )}
      {isOpen && type === 'cellphone' && (
        <ModifyChangeCellPhoneNumber setIsOpen={setIsOpen} />
      )}
    </Container>
  );
};

const Container = styled.section``;

const ModifyItemHasInputContainer = styled.section`
  height: 52.5px;
`;
const ModifyItemHasInputTitleWrapper = styled.article`
  width: 70px;
`;
const ModifyItemHasInputTitle = styled.h5``;
const ModifyItemHasInputTextWrapper = styled.article``;
const ModifyItemHasInputText = styled.p``;
const ModifyItemHasInputChangeButton = styled.div`
  right: 20px;
`;
const ModifyItemHasInputChangeButtonIcon = styled.i``;

export default ModifyItemHasInput;
